export const UPDATE_BOOKING_SETTING = "UPDATE_BOOKING_SETTING";
export const FETCH_BOOKING_SETTING = "FETCH_BOOKING_SETTING";
export const SET_BOOKING_SETTING = "SET_BOOKING_SETTING";
export const RESET_BOOKING_SETTING = "RESET_BOOKING_SETTING";
export const UPSERT_PRICING_CONFIG = "UPSERT_PRICING_CONFIG";

export const fetchBookingSetting = ({
  sport,
  location,
  includeSpecialOffers = false,
}) => ({
  type: FETCH_BOOKING_SETTING,
  payload: { sport, location, includeSpecialOffers },
});

export const setBookingSetting = ({ bookingSetting }) => ({
  type: SET_BOOKING_SETTING,
  payload: {
    bookingSetting: bookingSetting,
  },
});

export const updateBookingSetting = ({ json, sport, location }) => ({
  type: UPDATE_BOOKING_SETTING,
  payload: { json, sport, location },
});

export const upsertPricingConfig = ({ json, sport, location }) => ({
  type: UPSERT_PRICING_CONFIG,
  payload: { json, sport, location },
});

export const resetBookingSetting = () => ({
  type: RESET_BOOKING_SETTING,
});

const initialState = {
  bookingSetting: {},
};

const bookingSettingReducer = (state = initialState, action) => {
  if (action.type === SET_BOOKING_SETTING) {
    return {
      ...state,
      bookingSetting: action.payload,
    };
  }

  if (action.type === RESET_BOOKING_SETTING) {
    return initialState;
  }

  return state;
};

export default bookingSettingReducer;

export const getBookingSetting = ({ bookingSetting: { bookingSetting } }) =>
  bookingSetting;
